const CENTS_TO_DOLLARS_CONVERSION = 100

function centsToDollarsNumber(cents = 0, places = 2) {
    return (cents / CENTS_TO_DOLLARS_CONVERSION).toFixed(places)
}

export { centsToDollarsNumber }
